import { render } from "./VimeoVideo.vue?vue&type=template&id=72e939e3"
import script from "./VimeoVideo.vue?vue&type=script&lang=js"
export * from "./VimeoVideo.vue?vue&type=script&lang=js"

import "./VimeoVideo.vue?vue&type=style&index=0&id=72e939e3&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__